module.exports = __webpack_public_path__ + "static/media/wedding-catering-5.f9406bd2.jpg";